module.exports = "/images/vendor/flag-icon-css/flags/1x1/lu.svg?2585715a069b9b8234825e2ce1ef8ed6";